import { render, staticRenderFns } from "./TermsPopup.vue?vue&type=template&id=1de98764"
import script from "./TermsPopup.vue?vue&type=script&lang=js"
export * from "./TermsPopup.vue?vue&type=script&lang=js"
import style0 from "./TermsPopup.vue?vue&type=style&index=0&id=1de98764&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports